const productSubpageMobileStyles = `
.cms-page .vb-flow-mobile-title {
  display: none;
}

@media (max-width: 960px) {
  .cms-page .vb-hero,
  .cms-page .rr-hero,
  .cms-page .aa-hero,
  .cms-page .fb-hero,
  .cms-page .bo-hero,
  .cms-page .vb-claim,
  .cms-page .vb-flow,
  .cms-page .rr-claim,
  .cms-page .aa-claim,
  .cms-page .fb-claim,
  .cms-page .bo-claim,
  .cms-page .vb-final,
  .cms-page .rr-final,
  .cms-page .aa-final,
  .cms-page .fb-final,
  .cms-page .bo-final,
  .cms-page .vb-brandit,
  .cms-page .mc-section__head,
  .cms-page .cms-page__section-head {
    text-align: center;
  }

  .cms-page .vb-hero-inner,
  .cms-page .vb-brandit-inner,
  .cms-page .vb-flow-step,
  .cms-page .rr-hero-inner,
  .cms-page .aa-hero-inner,
  .cms-page .fb-hero-inner,
  .cms-page .bo-hero-inner,
  .cms-page .pblock-inner,
  .cms-page .rr-engine-inner,
  .cms-page .aa-builder-inner,
  .cms-page .aa-stream-grid,
  .cms-page .aa-clock-grid,
  .cms-page .bo-export-inner,
  .cms-page .bo-cust-grid,
  .cms-page .bo-rep,
  .cms-page .fb-deep-inner,
  .cms-page .fb-pat-grid,
  .cms-page .fb-int-grid {
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 28px;
  }

  .cms-page .vb-hero-left,
  .cms-page .vb-hero-inner > div:first-child,
  .cms-page .vb-brandit-inner > div:first-child,
  .cms-page .vb-flow-head,
  .cms-page .vb-flow-copy,
  .cms-page .rr-hero-copy,
  .cms-page .aa-hero-copy,
  .cms-page .fb-hero-copy,
  .cms-page .bo-hero-copy,
  .cms-page .pblock-inner > div:first-child,
  .cms-page .rr-engine-copy,
  .cms-page .aa-builder-copy,
  .cms-page .bo-export-copy,
  .cms-page .fb-deep-copy,
  .cms-page .section-head,
  .cms-page .mc-section__head,
  .cms-page .cms-page__section-head {
    text-align: center;
  }

  .cms-page .vb-hero-inner > div:first-child,
  .cms-page .vb-brandit-inner > div:first-child {
    justify-items: center;
  }

  .cms-page .eyebrow,
  .cms-page .kick,
  .cms-page .tag,
  .cms-page .pblock-kicker,
  .cms-page .section-eyebrow,
  .cms-page .mc-section__eyebrow,
  .cms-page .cms-page__eyebrow {
    display: inline-flex;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .cms-page .vb-hero h1,
  .cms-page .vb-brandit h2,
  .cms-page .vb-flow-head h2,
  .cms-page .vb-flow-copy h3,
  .cms-page .rr-hero h1,
  .cms-page .aa-hero h1,
  .cms-page .fb-hero h1,
  .cms-page .bo-hero h1,
  .cms-page .pblock h2,
  .cms-page .section-head h2,
  .cms-page .mc-section__heading,
  .cms-page .cms-page__section-title {
    text-align: center;
  }

  .cms-page .vb-hero p,
  .cms-page .vb-brandit p.lede,
  .cms-page .vb-flow-head p,
  .cms-page .vb-flow-copy p,
  .cms-page .rr-hero p,
  .cms-page .aa-hero p,
  .cms-page .fb-hero p,
  .cms-page .bo-hero p,
  .cms-page .pblock .lede,
  .cms-page .section-lede,
  .cms-page .mc-section__summary,
  .cms-page .cms-page__section-copy {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .cms-page .cta-row,
  .cms-page .vb-final-cta,
  .cms-page .rr-final-cta,
  .cms-page .aa-final-cta,
  .cms-page .fb-final-cta,
  .cms-page .bo-final .cta-row,
  .cms-page .mc-section__actions {
    align-items: stretch !important;
    flex-direction: column !important;
    width: 100%;
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .cta-row .btn,
  .cms-page .vb-final-cta .btn,
  .cms-page .rr-final-cta .btn,
  .cms-page .aa-final-cta .btn,
  .cms-page .fb-final-cta .btn,
  .cms-page .bo-final .btn,
  .cms-page .mc-section__actions .btn {
    justify-content: center;
    width: 100%;
  }

  .cms-page .vb-hero-stage,
  .cms-page .vbh-stage,
  .cms-page .rr-hero-card,
  .cms-page .aa-hero-card,
  .cms-page .fb-hero-card,
  .cms-page .bo-dash,
  .cms-page .live,
  .cms-page .pblock-inner > div:last-child,
  .cms-page .rr-engine-stage,
  .cms-page .aa-builder-stage,
  .cms-page .bo-panel,
  .cms-page .fb-device,
  .cms-page .fb-mock,
  .cms-page .pmock {
    width: 100%;
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .vb-hero,
  .cms-page .vb-flow,
  .cms-page .rr-hero,
  .cms-page .aa-hero,
  .cms-page .fb-hero,
  .cms-page .bo-hero,
  .cms-page .pblock,
  .cms-page .rr-engine,
  .cms-page .aa-builder,
  .cms-page .aa-stream,
  .cms-page .aa-clock,
  .cms-page .bo-cmd,
  .cms-page .bo-export,
  .cms-page .bo-perm,
  .cms-page .fb-deep,
  .cms-page .fb-pat,
  .cms-page .fb-int {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .cms-page .pblock,
  .cms-page .rr-engine,
  .cms-page .aa-builder,
  .cms-page .aa-stream,
  .cms-page .aa-clock,
  .cms-page .bo-export,
  .cms-page .bo-perm,
  .cms-page .fb-deep,
  .cms-page .fb-pat,
  .cms-page .fb-int {
    padding-top: 56px !important;
    padding-bottom: 56px !important;
  }

  .cms-page .vb-wall-grid,
  .cms-page .vb-mosaic-grid,
  .cms-page .rr-why-grid,
  .cms-page .rr-tl-grid,
  .cms-page .aa-wall-grid,
  .cms-page .bo-perm-grid,
  .cms-page .fb-int-icons,
  .cms-page .fb-pat-cards {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  .cms-page .aa-btn-grid,
  .cms-page .aa-actions,
  .cms-page .bo-tabs,
  .cms-page .fb-tabs,
  .cms-page .vb-brandbar,
  .cms-page .vb-ticker,
  .cms-page .rr-hero-stats,
  .cms-page .fb-hero-tabs {
    justify-content: center;
  }

  .cms-page .bo-tabs,
  .cms-page .fb-tabs {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .cms-page .bo-tabs button,
  .cms-page .fb-tabs button {
    flex: 1 1 140px;
    justify-content: center;
  }

  .cms-page .vb-brandbar-inner {
    flex-direction: column;
    align-items: center;
    gap: 18px;
    text-align: center;
  }

  .cms-page .vb-brandbar-label {
    width: 100%;
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .cms-page .vb-brandbar-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    justify-items: center;
    gap: 14px 22px;
  }

  .cms-page .vb-brandbar-grid .lg {
    flex: 0 1 auto;
    text-align: center;
  }

  .cms-page .vb-brandit-controls {
    width: 100%;
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
    align-items: stretch;
  }

  .cms-page .vb-brandit-controls > div,
  .cms-page .vb-swatches,
  .cms-page .vb-fontpicker,
  .cms-page .vb-radii {
    width: 100%;
  }

  .cms-page .vb-brandit-control-lbl {
    text-align: center;
  }

  .cms-page .vb-swatches,
  .cms-page .vb-fontpicker,
  .cms-page .vb-radii {
    justify-content: center;
  }

  .cms-page .vb-fontpicker button,
  .cms-page .vb-radii button {
    flex: 1 1 0;
    justify-content: center;
  }

  .cms-page .vbh-ticker {
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .cms-page .vbh-ticker-label,
  .cms-page .vbh-ticker-item {
    justify-content: center;
    text-align: center;
  }

  .cms-page .vb-flow-rail {
    display: none;
  }

  .cms-page .vb-flow-stage {
    display: grid;
    gap: 36px;
    width: 100%;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .cms-page .vb-flow-step,
  .cms-page .vb-flow-step.rev {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 18px;
    grid-template-columns: none !important;
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    text-align: center;
  }

  .cms-page .vb-flow-step.rev .vb-flow-copy,
  .cms-page .vb-flow-step.rev .vb-flow-viz {
    order: initial !important;
  }

  .cms-page .vb-flow-step > .vb-flow-copy {
    order: 1 !important;
  }

  .cms-page .vb-flow-step > .vb-flow-viz {
    order: 2 !important;
  }

  .cms-page .vb-flow-step > .vb-flow-mobile-title {
    order: 0 !important;
  }

  .cms-page .vb-flow-mobile-title {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    max-width: 520px;
    margin: 0 auto 2px;
    font-family: 'Graphik', ui-monospace, monospace;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: .1em;
    line-height: 1.35;
    text-align: center;
    text-transform: uppercase;
    color: #0f766e;
  }

  .cms-page .vb-flow-mobile-dot {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #fff;
    border: 3px solid #ccfbf1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Graphik', system-ui, sans-serif;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    color: #0f766e;
  }

  .cms-page .vb-flow-step.active .vb-flow-mobile-dot {
    background: #14b8a6;
    border-color: #14b8a6;
    color: #fff;
    box-shadow: 0 10px 24px -6px rgba(20, 184, 166, .5);
  }

  .cms-page .vb-flow-mobile-label {
    display: block;
    width: 100%;
    text-align: center;
  }

  .cms-page .vb-flow-copy {
    display: grid;
    justify-items: center;
    width: 100%;
    max-width: 560px;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .cms-page .vb-flow-num {
    display: none !important;
    width: auto !important;
    max-width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center !important;
    gap: 10px;
    place-self: center;
    margin-left: auto !important;
    margin-right: auto !important;
    margin-bottom: 8px;
    font-size: 13px;
    line-height: 1.35;
    letter-spacing: .1em;
    text-align: center;
  }

  .cms-page .vb-flow-num-dot {
    flex: 0 0 auto;
    margin: 0;
  }

  .cms-page .vb-flow-num-label {
    display: block;
    width: 100%;
    text-align: center;
  }

  .cms-page .vb-flow-copy h3 {
    width: 100%;
    max-width: 520px;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .cms-page .vb-flow-stat {
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .vb-flow-viz {
    width: 100%;
    max-width: 460px;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .vf-pipe {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .cms-page .vf-pipe-node {
    width: 100%;
    max-width: 220px;
    min-width: 0;
  }

  .cms-page .vf-pipe-line {
    width: 2px;
    height: 38px;
    background: linear-gradient(180deg, #e2e8f0, #635bff, #14b8a6);
  }

  .cms-page .vf-pipe-line::before {
    top: 0;
    left: -3px;
    animation-name: vfFlowMobile;
  }

  .cms-page .vb-mini-pm {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    margin-right: auto;
    max-width: 420px;
  }

  .cms-page .vb-mini-pm .pm {
    flex: 0 1 92px;
    width: 92px;
  }

  .cms-page .vb-intl {
    text-align: center;
  }

  .cms-page .vb-intl-head {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .cms-page .vb-intl-ic {
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .vb-intl-flags {
    justify-content: center;
    padding-left: 0 !important;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .rr-stage,
  .cms-page .rr-frame,
  .cms-page .rr-board {
    width: 100%;
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .rr-frame {
    padding: 18px;
  }

  .cms-page .rr-board {
    padding: 18px;
  }

  .cms-page .rr-board-head {
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    text-align: center;
  }

  .cms-page .rr-row {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    grid-template-columns: none !important;
    gap: 8px;
    padding: 16px 0;
    text-align: center;
  }

  .cms-page .rr-row .who {
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    min-width: 0;
    text-align: center;
  }

  .cms-page .rr-row .who > div:last-child {
    min-width: 0;
  }

  .cms-page .rr-row .who .em {
    overflow-wrap: anywhere;
  }

  .cms-page .rr-row .status {
    position: static !important;
    right: auto !important;
    bottom: auto !important;
    display: inline-flex;
    justify-content: center;
    max-width: 100%;
    white-space: normal;
    text-align: center;
  }

  .cms-page .rr-strat {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    text-align: center;
  }

  .cms-page .rr-strat-kpi {
    margin-left: 0;
    text-align: center;
  }

  .cms-page .aa-rail {
    width: 100%;
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .cms-page .aa-rail-lbl {
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .cms-page .aa-rail-chips {
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .aa-rail-chip {
    justify-content: center;
    text-align: center;
  }

  .cms-page .aa-wall-list {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 10px;
    width: 100%;
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
    text-align: left;
  }

  .cms-page .aa-wall-list li {
    display: block !important;
    width: 100%;
    text-align: left;
  }

  .cms-page .aa-wall-list li::before {
    display: inline-block;
    margin: 0 8px 0 0;
    vertical-align: -2px;
  }

  .cms-page .aa-wall-list li b {
    display: inline;
  }

  .cms-page .aa-log-row {
    display: grid !important;
    grid-template-columns: auto auto;
    justify-content: center;
    gap: 4px 10px;
    text-align: center;
  }

  .cms-page .aa-log-row .dt {
    grid-column: 1 / -1;
    overflow-wrap: anywhere;
  }

  .cms-page .bo-dash {
    transform: none !important;
  }

  .cms-page .bo-dash-inner {
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 12px;
    padding: 14px;
  }

  .cms-page .bo-table {
    display: grid;
    gap: 10px;
    padding: 12px;
  }

  .cms-page .bo-table .th {
    display: none !important;
  }

  .cms-page .bo-table .tr {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px 14px;
    padding: 12px;
    border: 1px solid #eef1f4;
    border-radius: 10px;
    text-align: left;
  }

  .cms-page .bo-table .tr > div:first-child {
    grid-column: 1 / -1;
  }

  .cms-page .bo-table .tr .pl,
  .cms-page .bo-table .tr .am,
  .cms-page .bo-table .tr .st {
    justify-self: start;
    text-align: left !important;
  }

  .cms-page .bo-table .tr .pl::before,
  .cms-page .bo-table .tr .am::before,
  .cms-page .bo-table .tr .st::before {
    display: block;
    margin-bottom: 2px;
    font-family: 'Graphik', ui-monospace, monospace;
    font-size: 8px;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: #94a3b8;
  }

  .cms-page .bo-table .tr .pl::before {
    content: "Plan";
  }

  .cms-page .bo-table .tr .am::before {
    content: "Amount";
  }

  .cms-page .bo-table .tr .st::before {
    content: "Status";
    display: inline;
    margin-right: 6px;
    margin-bottom: 0;
  }

  .cms-page .bo-subs-grid {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  .cms-page .bo-filters,
  .cms-page .bo-subs-table {
    grid-column: auto !important;
  }

  .cms-page .bo-stb {
    display: none !important;
  }

  .cms-page .bo-subs-table {
    display: grid;
    gap: 10px;
  }

  .cms-page .bo-str {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px 14px;
    padding: 12px;
    border: 1px solid #eef1f4;
    border-radius: 10px;
    text-align: left;
  }

  .cms-page .bo-str .cust {
    grid-column: 1 / -1;
    min-width: 0;
  }

  .cms-page .bo-str .cust > div:last-child {
    min-width: 0;
  }

  .cms-page .bo-str .cust .em {
    overflow-wrap: anywhere;
  }

  .cms-page .bo-str .pl,
  .cms-page .bo-str .am,
  .cms-page .bo-str .nx,
  .cms-page .bo-str .st {
    justify-self: start;
    text-align: left !important;
  }

  .cms-page .bo-str .pl::before,
  .cms-page .bo-str .am::before,
  .cms-page .bo-str .nx::before,
  .cms-page .bo-str .st::before {
    display: block;
    margin-bottom: 2px;
    font-family: 'Graphik', ui-monospace, monospace;
    font-size: 8px;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: #94a3b8;
  }

  .cms-page .bo-str .pl::before {
    content: "Plan";
  }

  .cms-page .bo-str .am::before {
    content: "Amount";
  }

  .cms-page .bo-str .nx::before {
    content: "Next";
  }

  .cms-page .bo-str .st::before {
    content: "Status";
  }

  .cms-page .bo-str.row-flash::after {
    position: static;
    grid-column: 1 / -1;
    transform: none;
    justify-self: start;
    margin-top: 2px;
  }

  .cms-page .bo-export-preview {
    width: 100%;
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .bo-csv {
    padding: 14px;
    overflow: visible;
  }

  .cms-page .bo-csv .h {
    display: none;
  }

  .cms-page .bo-csv #bo-csv-rows {
    display: grid;
    gap: 10px;
  }

  .cms-page .bo-csv #bo-csv-rows .r {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 8px 12px;
    padding: 12px;
    margin: 0;
    border: 1px solid rgba(148, 163, 184, .22);
    border-radius: 10px;
    background: rgba(15, 23, 42, .92);
    white-space: normal;
  }

  .cms-page .bo-csv #bo-csv-rows .r.new {
    margin: 0;
    padding: 12px;
  }

  .cms-page .bo-csv #bo-csv-rows .r > div {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .cms-page .bo-csv #bo-csv-rows .r > div:nth-child(2) {
    grid-column: 1 / -1;
  }

  .cms-page .bo-csv #bo-csv-rows .r > div::before {
    display: block;
    margin-bottom: 2px;
    font-family: 'Graphik', ui-monospace, monospace;
    font-size: 8px;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: #64748b;
  }

  .cms-page .bo-csv #bo-csv-rows .r > div:nth-child(1)::before {
    content: "ID";
  }

  .cms-page .bo-csv #bo-csv-rows .r > div:nth-child(2)::before {
    content: "Customer";
  }

  .cms-page .bo-csv #bo-csv-rows .r > div:nth-child(3)::before {
    content: "Amount";
  }

  .cms-page .bo-csv #bo-csv-rows .r > div:nth-child(4)::before {
    content: "Status";
  }

  .cms-page .bo-csv #bo-csv-rows .r > div:nth-child(5)::before {
    content: "Created";
  }

  .cms-page .fb-int-card {
    display: grid;
    justify-items: center;
    text-align: center;
  }

  .cms-page .fb-int-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .cms-page .fb-int-card .ic {
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .fb-int-card b,
  .cms-page .fb-int-card span {
    text-align: center;
  }

  @keyframes vfFlowMobile {
    to {
      top: 100%;
    }
  }
}

@media (max-width: 560px) {
  .cms-page .vb-hero h1,
  .cms-page .rr-hero h1,
  .cms-page .aa-hero h1,
  .cms-page .fb-hero h1,
  .cms-page .bo-hero h1 {
    font-size: 34px;
  }

  .cms-page .vb-hero-stage,
  .cms-page .vbh-stage,
  .cms-page .rr-hero-card,
  .cms-page .aa-hero-card,
  .cms-page .fb-hero-card,
  .cms-page .bo-dash,
  .cms-page .live,
  .cms-page .fb-device {
    max-width: 100%;
  }

  .cms-page .fb-int-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}
`

export default productSubpageMobileStyles
